
import { GoodsType } from '@/utils/common';
import { Form } from 'element-ui';
import moment from 'moment';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { addGoods } from '@/api/specialGoods';

@Component({
  filters: {
    local_time_str(val: number) {
      return moment(val * 1000).format('YYYY-MM-DD HH:mm:ss');
    },
  },
})
export default class SpecialGoodsItem extends Vue {
  @Prop({ default: false }) isEdit!: boolean;
  @Prop({ default: null }) detail!: any;
  private goodsCoin: number = GoodsType.COIN;
  private goodsCard: number = GoodsType.CARD;
  private intergerRegExp: any = /^[1-9]+[0-9]*$/; // 正整数
  private float1RegExp: any = /^[0-9]+(.[0-9]{1})?$/; // 一位小数的实数
  private float2RegExp: any = /^[0-9]+(.[0-9]{2})?$/; // 一位小数的实数
  private countRegExp: any = /^[0-9]*$/;
  private goodsForm: {
    name: string; // 商品名称
    type: number; // 商品类型
    coin_amount?: string; // 云币价格
    sub_card_amount?: number; // 周期卡时长
    sub_card_valid_day_remark?: string; // 周期卡时长说明
    sub_card_valid_days?: number; //激活后有效天数
    cost: number; // 商品金额
    expire_at: any; // 截止购买日期(timestamp)
    limit: number; // 购买次数
    desc?: string; // 商品说明
    open: boolean; // 状态
  } = {
    name: '',
    type: GoodsType.COIN,
    coin_amount: '',
    sub_card_amount: 0,
    sub_card_valid_day_remark: '',
    sub_card_valid_days: 0,
    cost: 0,
    expire_at: '',
    limit: 0,
    desc: '',
    open: true,
  };

  @Watch('isEdit', { deep: true })
  isEditChange(newVal: any) {
    if (newVal) {
      console.log('显示商品详情: ', newVal);
      this.showDetail(this.detail);
    } else {
      this.resetForm('goodsForm');
    }
  }

  /**
   * 验证云币
   */
  private checkShowPrice(rule: any, value: any, callback: any) {
    if (this.goodsForm.type !== this.goodsCoin) {
      //不是选的云币
      return callback();
    }
    if (!this.intergerRegExp.test(value)) {
      return callback(new Error('云币面额请填入整数'));
    } else {
      return callback();
    }
  }

  private checkDurationRegExp(rule: any, value: any, callback: any) {
    if (this.goodsForm.type !== this.goodsCard) {
      return callback();
    }
    if (!this.intergerRegExp.test(value)) {
      return callback(new Error('请输入周期卡时长'));
    } else {
      return callback();
    }
  }
  private checkCardIndateRegExp(rule: any, value: any, callback: any) {
    if (this.goodsForm.type !== this.goodsCard) {
      return callback();
    }
    if (!value) {
      return callback(new Error('请输入周期卡有效期说明'));
    } else {
      return callback();
    }
  }
  private checkCardValidDaysRegExp(rule: any, value: any, callback: any) {
    if (this.goodsForm.type !== this.goodsCard) {
      return callback();
    }
    if (!this.intergerRegExp.test(value)) {
      return callback(new Error('请输入周期卡激活后的有效天数'));
    } else {
      return callback();
    }
  }

  private checkCostPrice(rule: any, value: any, callback: any) {
    const floatRegExt = location.href.indexOf('localhost') > -1 ? this.float2RegExp : this.float1RegExp;
    if (!value) {
      return callback(new Error('请输入商品金额'));
    } else if (!floatRegExt.test(value)) {
      return callback(new Error('商品金额保留一位小数'));
    } else {
      return callback();
    }
  }

  private checkCountLimit(rule: any, value: any, callback: any) {
    if (!this.countRegExp.test(value)) {
      return callback(new Error('购买次数格式不正确'));
    }
    return callback();
  }

  private rules: any = {
    name: [
      { required: true, message: '请输入商品名称', trigger: 'blur' },
      { max: 20, message: '商品名称最多20个字符', trigger: 'blur' },
    ],
    type: [{ required: true, message: '请选择商品类型', trigger: 'blur' }],
    coin_amount: [{ validator: this.checkShowPrice, trigger: 'blur' }],
    sub_card_amount: [{ validator: this.checkDurationRegExp, trigger: 'blur' }],
    sub_card_valid_day_remark: [{ validator: this.checkCardIndateRegExp, trigger: 'blur' }],
    sub_card_valid_days: [{ validator: this.checkCardValidDaysRegExp, trigger: 'blur' }],
    cost: [
      { required: true, message: '请输入商品金额', trigger: 'blur' },
      { validator: this.checkCostPrice, trigger: 'blur' },
    ],
    expire_at: [{ required: true, message: '请选择购买截止时间', trigger: 'blur' }],
    limit: [
      { required: true, message: '请输入购买次数', trigger: 'blur' },
      { validator: this.checkCountLimit, trigger: 'blur' },
    ],
    desc: [{ required: true, message: '请输入商品描述', trigger: 'blur' }],
  };

  submitForm(formName: string) {
    (this.$refs[formName] as Form).validate(valid => {
      if (valid) {
        const formData = JSON.parse(JSON.stringify(this.goodsForm));
        if (formData.expire_at) {
          formData.expire_at = Math.floor(new Date(formData.expire_at).getTime() / 1000);
        }
        if (formData.cost) {
          formData.cost = parseInt((formData.cost * 100).toFixed(0));
        }
        this.submitConfirm(formData);
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }

  private showDetail(detail: any) {
    this.goodsForm = JSON.parse(JSON.stringify(detail));
    if (detail.cost) {
      this.goodsForm.cost = parseFloat((this.goodsForm.cost / 100).toFixed(2));
    }
  }

  private goodsAdded() {
    this.resetForm('goodsForm');
    this.$emit('goodsAdded');
    this.$message({
      type: 'success',
      message: '保存成功!',
    });
  }

  submitConfirm(formData: any) {
    this.$confirm('确认提交吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        // console.log('提交表单: ', formData);
        if (formData.type === GoodsType.COIN) {
          formData.sub_card_amount = 0;
          formData.sub_card_valid_day_remark = '';
          formData.sub_card_valid_days = 0;
        } else {
          formData.coin_amount = 0;
        }
        addGoods(formData).then(() => {
          this.goodsAdded();
        });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消保存',
        });
      });
  }

  resetForm(formName: string) {
    (this.$refs[formName] as Form).resetFields();
  }
  mounted() {
    if (this.detail) {
      this.showDetail(this.detail);
    } else {
      this.resetForm('goodsForm');
    }
  }
}
